import axios from 'axios';
import { EncryptionPassword, encryptObject } from './encryptDecrypt';
import { CryptoPassword, decryptedText } from "./crypto";
import {
    POSFlow,
    POS_DEVICE_WIDTH,
    StatusPending,
    TypeEcommerce,
    TypePOS,
    encodeContent,
    shortenValue
} from './helper';
import { baseURL, toBasePayURL } from './env';

export const onStoreData = async (
    itemList: any,
    grandTotal: any,
    merchantId: any,
    getMerchantCurrency: any,
    titleName: any,
    setOnBtnLoader: any,
    getToken: any,
    onErrorCall: any,
    setPaymentIframeURL: any
) => {
    const getWalletEmail = localStorage.getItem("ec-email");
    const modifyResp = itemList.map((item: any, i: any) => {
        return {
            categories: item.product.categories,
            img: item.product.img,
            price: item.product.price,
            product_id: item.product.product_id,
            name: item.product.product_name,
            sku: item.product.sku,
            oqty: item.qty,
        };
    });
    const newObject = {
        merchant_id: merchantId,
        currency: getMerchantCurrency,
        amount: shortenValue(grandTotal),
        name: " ",
        client_address: " ",
        date_time: " ",
        digest: " ",
        product_detail: modifyResp,
        status: StatusPending,
        merchant_email: decryptedText(CryptoPassword, getWalletEmail),
        order_type: titleName === POSFlow ? TypePOS : TypeEcommerce,
        recaptchaToken: getToken,
    };
    const enctyptData = await encryptObject(newObject, EncryptionPassword);
    try {
        axios.post(`${baseURL}merchant_orders`, { raw_data: enctyptData })
            .then((response: any) => {
                if (response && response.data !== null && response.data.order_id) {
                    const orderType = titleName === POSFlow ? `pos=${response.data.order_id}` : `ecommerce=${response.data.order_id}`;
                    const generateKey = encodeContent(orderType);
                    setOnBtnLoader(false);
                    window.innerWidth == POS_DEVICE_WIDTH ? setPaymentIframeURL(`${toBasePayURL}/${generateKey}`) : window.location.replace(`${toBasePayURL}/${generateKey}`)
                } else {
                    response && response.data && response.data.message && onErrorCall(response.data.message)
                }
            }).catch((error) => { error && error.message && onErrorCall(error.message); });
    } catch (error: any) { }
};